import { floorPlanElementUuid } from './floor-plan-uuid';

/**
 * English comment normalized.
 * English comment normalized.
 * and the helper is imported from **`src`** (e.g. demo from **`upp-test`**).
 */
export function konvaShapeByUuidFromModel<S extends { uuid: string }>(
  model: { readonly shapes: Iterable<S> },
  uuid: string,
): S | null {
  const t = uuid.trim();
  for (const s of model.shapes) {
    if (s.uuid === t) {
      return s;
    }
  }
  const seeded = floorPlanElementUuid(t);
  for (const s of model.shapes) {
    if (s.uuid === seeded) {
      return s;
    }
  }
  return null;
}
